import { render } from "./Comments.vue?vue&type=template&id=36994245&scoped=true&ts=true&lang=pug"
import script from "./Comments.vue?vue&type=script&lang=ts"
export * from "./Comments.vue?vue&type=script&lang=ts"

import "./Comments.vue?vue&type=style&index=0&id=36994245&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36994245"]])

export default __exports__